module.exports = __webpack_public_path__ + "static/media/grandine-circle.9c201049.png";